import { timeParse, timeFormat } from "d3";
import { apiService } from "@/_services";
import { formatDate_YMD, timeParseNull2 } from "@/_core/_helpers/_helpers";

/**
 * Fetches and processes the historical futures curve for a given commodity.
 * @param {object} _this - Context variables, usually the Vue component instance.
 * @param {string} commodityPK - Primary key of the commodity.
 * @param {Date} initDate - Initial date for fetching data.
 * @param {object} processData - Data processing functions.
 * @param {string} fieldName - Field where the fetched data will be stored.
 * @param {string} fieldShowLoadingName - Field tracking the loading state.
 */
export async function getCommodityCurveAnalysis(
  _this,
  commodityPK,
  initDate,
  processData,
  fieldName,
  fieldShowLoadingName
) {
  // Reset UI selections and set loading states
  Object.assign(_this.userSelections, { isCandles: null });
  Object.assign(_this.loading, {
    historical: true,
    historicalProcess: true,
    curveProcess: true
  });
  _this[fieldShowLoadingName] = true;
  let params = {
    method: "GET",
    endpoint: "commodities_curve",
    content_type: "application/json",
    query_params: {
      format: "json",
      commodity: commodityPK,
      observation_date: formatDate_YMD(initDate)
    }
  };
  return apiService
    .getAll(params)
    .then(data => parseData(data, _this))
    .catch(error => {
      _this[fieldShowLoadingName] = false;
      _this[fieldName] = [];
      console.error("Error fetching commodity curve data:", error);
    });
}

/**
 * Parses raw futures curve data and updates the Vue component state.
 * @param {Array} data - Raw data fetched from API or CSV.
 * @param {object} _this - Context variables, usually the Vue component instance.
 */
export function parseData(data, _this) {
  let curve = {};
  let keys = Object.keys(data[data.length - 1]);
  keys = keys.filter(
    d =>
      ![
        "index",
        "date",
        "open",
        "high",
        "low",
        "close",
        "contract_month_year"
      ].includes(d)
  );
  let keyDate = keys.map(d => timeParse("%b%Y")(d)).sort((a, b) => a - b);
  keyDate = keyDate.map(d => new Date(d.setFullYear(d.getFullYear() + 2000)));
  keys = keyDate.map(d => timeFormat("%b%y")(d).toUpperCase());
  Object.assign(_this.allData, { keys, keyDate });
  data.forEach(d => {
    d.date = timeParseNull2(d.date);
    d.id = +d.date;
    d.zero = 0;
    let dat = keys.map((key, i) => ({
      date: keyDate[i],
      hovered: d[key],
      id: +keyDate[i]
    }));
    curve[d.id] = dat;
  });
  Object.assign(_this.allData, { historical: data, curve });
  Object.assign(_this.loading, { historical: false });
}
